export const enum STATUS_PILL_TYPES {
	DEFAULT = 'default',
	NOTICE = 'notice',
	WARNING = 'warning',
	SUCCESS = 'success',
	ERROR = 'error'
}

export const enum STATUS_PILL_SIZES {
	XS = 'xs',
	SM = 'sm',
	MD = 'md',
	LG = 'lg'
}
